var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgPlus = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    shapeRendering: "crispEdges",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5 4C13.8866 4 14.2 4.3134 14.2 4.7V13.8H23.3C23.6866 13.8 24 14.1134 24 14.5C24 14.8866 23.6866 15.2 23.3 15.2H14.2V24.3C14.2 24.6866 13.8866 25 13.5 25C13.1134 25 12.8 24.6866 12.8 24.3V15.2H3.7C3.3134 15.2 3 14.8866 3 14.5C3 14.1134 3.3134 13.8 3.7 13.8H12.8V4.7C12.8 4.3134 13.1134 4 13.5 4Z",
    fill: "#111111"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPlus, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/plus.6305553a.svg";
export { ForwardRef as ReactComponent };